// extracted by mini-css-extract-plugin
module.exports = {"Container":"DealerCard_Container__14Khf","DealerCard":"DealerCard_DealerCard__2SjLu"};